module.exports = __webpack_public_path__ + "img/37106-012.a24982f1.jpg";